import defaultClient from '@src/api/clients/default';

const URL = (path) => {
  return `dashboard/client-summary/${path}/`;
};

export function fetchClientSummaryByDate(payload = {}) {
  return defaultClient.request({
    url: URL('client-date'),
    payload,
  });
}

export function fetchVerticalSummary(payload = {}) {
  return defaultClient.request({
    url: URL('vertical'),
    payload,
  });
}

export default {
  fetchClientSummaryByDate,
  fetchVerticalSummary,
};
